import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
// import { CampaignMessagesReportTableComponent } from '../../../../../components/tables/campaign-messages-report-table/campaign-messages-report-table.component';
// import { CampaignRecipientsReportTableComponent } from '../../../../../components/tables/campaign-recipients-report-table/campaign-recipients-report-table.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-reports',
  standalone: true,
  imports: [
    CommonModule,
   RouterOutlet
  ],
  templateUrl: './reports.component.html',
})
export class ReportsComponent {}
